import React, { type FC, memo } from "react";
import Text from "../../../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "./Overview.module.scss";
import summaryStyles from "../Summary.module.scss";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../../../redux/store";
import SummarySpecifications from "../SummarySpecifications";
import Price from "../../../../common/price/Price";
import { useTabsContext } from "../SummaryTabsContext";
import type { SummaryTabPropsTypes } from "../../../../../../hooks/useAphSummaryTabs";
import OverviewEngine from "./OverviewEngine";
import OverviewColour from "./OverviewColour";
import OverviewWheels from "./OverviewWheels";
import OverviewUpholstery from "./OverviewUpholstery";
import OverviewPacksAndExtras from "./OverviewPacksAndExtras";
import OverviewChargers from "./OverviewCharging";
import a11y from "../../../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import { GrCode } from "../../../../../../../../../common-deprecated/constants";
import GRLogo from "../../../../../../../../../../assets/toyota/svg/GR/TME-GR.svg";
import GRLogoSport from "../../../../../../../../../../assets/toyota/svg/GR/TME-GR-sport-black.svg";
import { getGrLogo } from "../../../../../../../../../common-deprecated/utils";
import SummaryServices from "../SummaryServices";
import SummaryManufacturerInfo from "../SummaryManufacturerInfo";

const SummaryOverview: FC<SummaryTabPropsTypes> = (props) => {
    const { tabId, tab } = props;
    const tabsContext = useTabsContext();
    const car = useCarConfigSelector((state) => state.car);
    const customFormatting = useCarConfigSelector((state) => state.carConfigSettings.customStartingPriceFormatting);
    const grLogo = getGrLogo(car.model.webtitleSectionName, car.grade.webtitleSectionName);

    return (
        <section
            className={summaryStyles["tab-panel"]}
            role="tabpanel"
            id={tabId}
            aria-labelledby={tab}
            hidden={tabsContext.openTab !== "overview"}
        >
            <div className={styles.carTitle}>
                {grLogo && (
                    <span>
                        {grLogo === GrCode.Gr ? <GRLogo aria-hidden="true" /> : <GRLogoSport aria-hidden="true" />}
                        <span className={a11y["sr-only"]}>
                            <CarConfigLabel label="carConfigGazooRacing" />
                        </span>
                    </span>
                )}
                <Text tag="h3" variant="apheleia-h4">
                    {car.model.webtitleSectionName} <strong>{car.grade.webtitleSectionName}</strong>
                </Text>
            </div>
            <div className={styles.startprice}>
                <Text tag="div" variant="apheleia-body" className={styles.title}>
                    <CarConfigLabel label="carConfigOverviewTilePriceStartingPrice" />
                </Text>
                <div>
                    <Price price={car.price} customFormatting={customFormatting} />
                </div>
            </div>
            <div>
                <ul className={styles.mainlist} role="list">
                    <OverviewEngine />
                    <OverviewColour />
                    <OverviewWheels />
                    <OverviewUpholstery />
                    <OverviewPacksAndExtras />
                    <OverviewChargers />
                </ul>
                <SummaryServices />
                <SummaryManufacturerInfo />
                <SummarySpecifications />
            </div>
        </section>
    );
};

export default memo(SummaryOverview);
